import React, { Component } from 'react';

import ReactSelect from 'react-select'
import "./select.css";
import FilterData from '../../utils/strings/FilterData';
//https://github.com/jedwatson/react-select

class Select extends Component{
	constructor (props){
		super(props);
		this.state = {value:props.value};
		this.onChange = this.onChange.bind(this);
	}

	onChange (value) {
		this.setState({
			value: value
		});
	}

  render() {
		const _val = this.state.value;
    return (
      <div className="box-input">
          <div className="box-input--title">{this.props.title}</div>
          <div className="box-input--select">
					<ReactSelect
							value={_val}
							blurInputOnSelect={true}
							onChange={this.props.onChange ? this.props.onChange : this.onChange}
							className={this.props.classes}
							classNamePrefix={this.props.classNamePrefix}
							defaultValue={this.props.defaultValue}
							isDisabled={this.props.isDisabled}
							isSearchable={this.props.isSearchable}
							name={this.props.name}
							options={this.props.options}
						/>
          </div>
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/form/Select.js